import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=c11e8f3a&"
import script from "./Payroll.vue?vue&type=script&lang=js&"
export * from "./Payroll.vue?vue&type=script&lang=js&"
import style0 from "./Payroll.vue?vue&type=style&index=0&id=c11e8f3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports